const MONTHLIST = [
	{
		value: '01',
		label: '一月份'
	}, {
		value: '02',
		label: '二月份'
	}, {
		value: '03',
		label: '三月份'
	}, {
		value: '04',
		label: '四月份'
	}, {
		value: '05',
		label: '五月份'
	}, {
		value: '06',
		label: '六月份'
	}, {
		value: '07',
		label: '七月份'
	}, {
		value: '08',
		label: '八月份'
	}, {
		value: '09',
		label: '九月份'
	}, {
		value: '10',
		label: '十月份'
	}, {
		value: '11',
		label: '十一月份'
	}, {
		value: '12',
		label: '十二月份'
	}
]

const YEARLIST = [
	{
		value: '2022',
        label: '2022年'
	},
	{
		value: '2023',
        label: '2023年'
	},
	{
		value: '2024',
        label: '2024年'
	},
	{
		value: '2025',
        label: '2025年'
	}
]

const DEPARTMENTLIST = [
	{
		value: '质量安全室',
        label: '质量安全室'
	},{
		value: '总师办',
		label: '总师办'
	},{
		value: '财务室',
		label: '财务室'
	},{
		value: '起重机械室',
		label: '起重机械室'
	},{
		value: '行政室',
		label: '行政室'
	},{
		value: '科研室',
		label: '科研室'
	},{
		value: '理化检测室',
		label: '理化检测室'
	},{
		value: '院领导',
		label: '院领导'
	},{
		value: '政工室',
		label: '政工室'
	},{
		value: '定检室',
		label: '定检室'
	},{
		value: '容器管道检验室',
		label: '容器管道检验室'
	},{
		value: '综合检验室',
		label: '综合检验室'
	},{
		value: '监检室',
		label: '监检室'
	},{
		value: '锅炉检验室',
		label: '锅炉检验室'
	},{
		value: '大亚湾工作站',
		label: '大亚湾工作站'
	},{
		value: '技术开发室',
		label: '技术开发室'
	},{
		value: '业务大厅',
		label: '业务大厅'
	}
]

const ATTENDANCETYPE = [
	{
		'typeName': '在岗',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '出差',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '学习',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '事假',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '病假',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '带薪假',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '产假',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '旷工',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '迟到',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '早退',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '加班',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '其他',
		'duration': 0,
		'count': 0,
	},
]

const NEWATTENDANCETYPE = [
	{
		'typeName': '在岗',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '出差',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '学习',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '事假',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '病假',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '带薪假',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '产假',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '旷工',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '迟到',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '早退',
		'duration': 0,
		'count': 0,
	}
]

const SPTYPE = [
	{
		'typeName': '事假',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '病假',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '带薪假',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '婚假',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '产假',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '育儿假',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '护理假',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '旷工',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '迟到',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '早退',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '其他',
		'duration': 0,
		'count': 0,
	},
]

const WORKTYPE = [
	{
		'typeName': '在岗',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '出差',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '加班',
		'duration': 0,
		'count': 0,
	},{
		'typeName': '其他情况',
		'duration': 0,
		'count': 0,
	},
]

const KEY_TO_NAME = {
  //商品信息
  name: '商品名称',category: '商品目录',description: '商品介绍',price: '商品单价',stock: '库存',status: '是否可用',tags: '商品标签',
  createdAt: '商品创建日期',updatedAt: '商品更新日期',coverImage: '商品封面图',
  //批次兑换码
  batchName: '批次名称', createTime: '批次创建日期',expireTime: '批次过期时间',total:'兑换码总数',
  code: '兑换码',nickName: '使用者名称',
  //优惠券
  couponName: '优惠券名称', couponPrice: '优惠金额', usePrice: '使用条件',expireDay: '有效天数',
  categoryName: '大类名称',
  //通用
  remark: '备注'
}

const KEY_TO_NAME_UPLOAD = {
  //文件上传
  type: '文件类型',name: '文件夹名称',createdAt: '文件夹创建时间'
}

const KEY_TO_NAME_ORDERS = {
  orderNo: '订单号',transId: '微信交易单号',
  waybillNo: '运单号',total: '购买总金额',paymentMethod: '支付方式', status: '订单状态' ,payTime: '支付时间', createdAt: '订单创建时间',nickName: '用户昵称', phone: '用户联系方式'
}

const KEY_TO_NAME_REFUND = {
  orderNo: '订单号',transId: '微信交易单号', refundNo :'退款单号',
  waybillNo: '运单号',total: '购买总金额',paymentMethod: '支付方式', status: '订单状态' ,payTime: '支付时间', nickName: '用户昵称', phone: '用户联系方式',
  reason: '退款原因', mediaUrls: '照片', processStatus: '退款状态', createdAt: '退款创建时间', updatedAt: '状态更新时间'
}



let departMentName = ''

let year = ''

let month = ''

let departMentId = -1

let departMentList = []

let inputMachineNO = ''

let inputName = ''

let copyData = {};

let outThis;

let selectMachine = {};

//搜索列
let searchObj = {};

export default{
	MONTHLIST,
	YEARLIST,
	DEPARTMENTLIST,
	ATTENDANCETYPE,
	year,
	month,
	departMentId,
	departMentName,
	departMentList,
	inputMachineNO,
	inputName,
	NEWATTENDANCETYPE,
	SPTYPE,
	WORKTYPE,

  copyData,
  outThis,
  KEY_TO_NAME,

  selectMachine,

  searchObj,

  KEY_TO_NAME_UPLOAD,
  KEY_TO_NAME_ORDERS,
  KEY_TO_NAME_REFUND
}



//////////////////
// WEBPACK FOOTER
// ./static/commondata.js
// module id = null
// module chunks = 